import { forwardRef } from 'react';
import { IntrinsicElementsKeys } from 'src/shared/types/utils';
import { isLocalBuild } from 'src/utils';
import { Box, BoxProps, ForwardRefBoxComponent } from '../Box';

export type FlexProps<T extends IntrinsicElementsKeys = 'div'> = BoxProps<T>;

export const Flex = forwardRef<HTMLDivElement, FlexProps>((props, ref) => (
  <Box display="flex" {...props} ref={ref} />
)) as ForwardRefBoxComponent;

if (isLocalBuild) {
  Flex.displayName = 'Flex';
}
